"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Course = void 0;
const StringBuilder_1 = require("../../utils/StringBuilder");
const CommandType_1 = require("../command/lib/CommandType");
const MetadataProperty_1 = require("../common/MetadataProperty");
const Player_1 = require("../common/Player");
const CourseVariant_1 = require("./CourseVariant");
const Difficulty_1 = require("./lib/Difficulty");
const Style_1 = require("./lib/Style");
/**
 * Represents a course in a song.
 */
class Course {
    constructor() {
        /**
         * The difficulty of the course.
         */
        this.difficulty = Difficulty_1.Difficulty.Oni;
        /**
         * The star rating of the course. It is an integer between 1 and 10.
         */
        this.stars = 10;
        /**
         * The SINGLE style course variant of this course.
         */
        this.singleCourse = new CourseVariant_1.CourseVariant();
        /**
         * The DOUBLE style course variant of this course.
         */
        this.doubleCourse = new CourseVariant_1.CourseVariant();
        this._activeCourseStyle = Style_1.Style.Single;
        this._activePlayer = Player_1.Player.Player1;
    }
    /**
     * Returns the currently selected course variant. It is determined by the
     * active course style.
     */
    get activeCourse() {
        return this._activeCourseStyle === Style_1.Style.Single
            ? this.singleCourse
            : this.doubleCourse;
    }
    /**
     * Sets the active course style. The `activeCourse` getter will return the
     * course variant based on this style value.
     */
    set activeCourseStyle(style) {
        this._activeCourseStyle = style;
    }
    /**
     * Add a command to the command buffer of the active course variant.
     * @param command - The command object to add.
     */
    addCommand(command) {
        if (command.commandType === CommandType_1.CommandType.Start) {
            const startCommand = command;
            if (startCommand.player) {
                this._activePlayer = startCommand.player;
            }
        }
        this.activeCourse.addCommand(command, this._activePlayer);
    }
    /**
     * Sets the gauge at a given index to the provided gauge data on the active
     * course variant.
     * @param index - The index to set.
     * @param gauge - The gauge data.
     */
    setGauge(index, gauge) {
        this.activeCourse.setGauge(index, gauge);
    }
    /**
     * Converts the course data into TJA format.
     * @returns - A string that will correspond to a single course in a TJA file.
     */
    toString() {
        const builder = new StringBuilder_1.StringBuilder()
            .withSeparator('\n')
            .append(`${MetadataProperty_1.CourseMetadataProperty.Course}:${this.difficulty}`)
            .append(`${MetadataProperty_1.CourseMetadataProperty.Level}:${this.stars}`)
            .append('\n');
        if (!this.singleCourse.isEmpty()) {
            builder.append(this.singleCourse.toString()).append('\n');
        }
        if (!this.doubleCourse.isEmpty()) {
            builder.append(this.doubleCourse.toString()).append('\n');
        }
        return builder.toString();
    }
}
exports.Course = Course;
